// utils/usStates.js
// Single source for US state name / flag / route data. Previously inlined in
// IntegratedSearchNavBar; extracted so pages that need to resolve a stored
// 'homeState' key (a slug like "newyork") into a display name and flag can do so
// without duplicating the table.

export const US_STATES_DATA = [
    { name: "Alabama", flag: "/alabamaFlag.png", path: "/us/alabama", key: "alabama" },
    { name: "Alaska", flag: "/alaskaFlag.png", path: "/us/alaska", key: "alaska" },
    { name: "Arizona", flag: "/arizonaFlag.png", path: "/us/arizona", key: "arizona" },
    { name: "Arkansas", flag: "/arkansasFlag.png", path: "/us/arkansas", key: "arkansas" },
    { name: "California", flag: "/californiaFlag.png", path: "/us/california", key: "california" },
    { name: "Colorado", flag: "/coloradoFlag.png", path: "/us/colorado", key: "colorado" },
    { name: "Connecticut", flag: "/connecticutFlag.png", path: "/us/connecticut", key: "connecticut" },
    { name: "Delaware", flag: "/delawareFlag.png", path: "/us/delaware", key: "delaware" },
    { name: "Florida", flag: "/floridaFlag.png", path: "/us/florida", key: "florida" },
    { name: "Georgia", flag: "/georgiaFlag.png", path: "/us/georgia", key: "georgia" },
    { name: "Hawaii", flag: "/hawaiiFlag.png", path: "/us/hawaii", key: "hawaii" },
    { name: "Idaho", flag: "/idahoFlag.png", path: "/us/idaho", key: "idaho" },
    { name: "Illinois", flag: "/illinoisFlag.png", path: "/us/illinois", key: "illinois" },
    { name: "Indiana", flag: "/indianaFlag.png", path: "/us/indiana", key: "indiana" },
    { name: "Iowa", flag: "/iowaFlag.png", path: "/us/iowa", key: "iowa" },
    { name: "Kansas", flag: "/kansasFlag.png", path: "/us/kansas", key: "kansas" },
    { name: "Kentucky", flag: "/kentuckyFlag.png", path: "/us/kentucky", key: "kentucky" },
    { name: "Louisiana", flag: "/louisianaFlag.png", path: "/us/louisiana", key: "louisiana" },
    { name: "Maine", flag: "/maineFlag.png", path: "/us/maine", key: "maine" },
    { name: "Maryland", flag: "/marylandFlag.png", path: "/us/maryland", key: "maryland" },
    { name: "Massachusetts", flag: "/massachusettsFlag.png", path: "/us/massachusetts", key: "massachusetts" },
    { name: "Michigan", flag: "/michiganFlag.png", path: "/us/michigan", key: "michigan" },
    { name: "Minnesota", flag: "/minnesotaFlag.png", path: "/us/minnesota", key: "minnesota" },
    { name: "Mississippi", flag: "/mississippiFlag.png", path: "/us/mississippi", key: "mississippi" },
    { name: "Missouri", flag: "/missouriFlag.png", path: "/us/missouri", key: "missouri" },
    { name: "Montana", flag: "/montanaFlag.png", path: "/us/montana", key: "montana" },
    { name: "Nebraska", flag: "/nebraskaFlag.png", path: "/us/nebraska", key: "nebraska" },
    { name: "Nevada", flag: "/nevadaFlag.png", path: "/us/nevada", key: "nevada" },
    { name: "New Hampshire", flag: "/newHampshireFlag.png", path: "/us/newhampshire", key: "newhampshire" },
    { name: "New Jersey", flag: "/newJerseyFlag.png", path: "/us/newjersey", key: "newjersey" },
    { name: "New Mexico", flag: "/newMexicoFlag.png", path: "/us/newmexico", key: "newmexico" },
    { name: "New York", flag: "/newYorkFlag.png", path: "/us/newyork", key: "newyork" },
    { name: "North Carolina", flag: "/northCarolinaFlag.png", path: "/us/northcarolina", key: "northcarolina" },
    { name: "North Dakota", flag: "/northDakotaFlag.png", path: "/us/northdakota", key: "northdakota" },
    { name: "Ohio", flag: "/ohioFlag.png", path: "/us/ohio", key: "ohio" },
    { name: "Oklahoma", flag: "/oklahomaFlag.png", path: "/us/oklahoma", key: "oklahoma" },
    { name: "Oregon", flag: "/oregonFlag.png", path: "/us/oregon", key: "oregon" },
    { name: "Pennsylvania", flag: "/pennsylvaniaFlag.png", path: "/us/pennsylvania", key: "pennsylvania" },
    { name: "Rhode Island", flag: "/rhodeIslandFlag.png", path: "/us/rhodeisland", key: "rhodeisland" },
    { name: "South Carolina", flag: "/southCarolinaFlag.png", path: "/us/southcarolina", key: "southcarolina" },
    { name: "South Dakota", flag: "/southDakotaFlag.png", path: "/us/southdakota", key: "southdakota" },
    { name: "Tennessee", flag: "/tennesseeFlag.png", path: "/us/tennessee", key: "tennessee" },
    { name: "Texas", flag: "/texasFlag.png", path: "/us/texas", key: "texas" },
    { name: "Utah", flag: "/utahFlag.png", path: "/us/utah", key: "utah" },
    { name: "Vermont", flag: "/vermontFlag.png", path: "/us/vermont", key: "vermont" },
    { name: "Virginia", flag: "/virginiaFlag.png", path: "/us/virginia", key: "virginia" },
    { name: "Washington", flag: "/washingtonFlag.png", path: "/us/washington", key: "washington" },
    { name: "West Virginia", flag: "/westVirginiaFlag.png", path: "/us/westvirginia", key: "westvirginia" },
    { name: "Wisconsin", flag: "/wisconsinFlag.png", path: "/us/wisconsin", key: "wisconsin" },
    { name: "Wyoming", flag: "/wyomingFlag.png", path: "/us/wyoming", key: "wyoming" }
  ];
  
  // The stored key ("newyork") and the API's display name ("New York") differ only
  // by case and spacing, so both collapse to the same slug for comparison.
  export const slugifyState = (value) => (value || '').toLowerCase().replace(/[^a-z]/g, '');
  
  // Resolve a stored 'homeState' key, or any display name, to the full record.
  // Returns null for values with no entry -- DC and the territories send members
  // to the House but have no flag asset here, so callers should handle null.
  export const getStateInfoByKey = (value) => {
    if (!value) return null;
    const slug = slugifyState(value);
    return US_STATES_DATA.find((state) => state.key === slug) || null;
  };